import React from "react";

const HeaderCard = ({ title, children, className }) => {
  return (
    <div className=" flex-1 border border-gray-200 rounded-md">
      <div
        className={`bg-black text-white px-4 py-1.5 rounded-t-md ${className}`}
      >
        {title}
      </div>
      <div className="p-4">{children}</div>
    </div>
  );
};

export default HeaderCard;
